export const FINANCE_REGULATORY = 'finance_regulatory';
export const INSIGHTS = 'insights';
